/**
 * Public pricing shown on the marketing landing page.
 * Keep in sync with Salovare.API.Services.Payments.BillingCatalogDefaults.
 */
export const LANDING_PRICING_CURRENCY = 'EUR';

export const LANDING_PRICING = {
  trialDays: 30,
  baseSubscriptionMonthly: 14.9,
  introductoryMonthly: 9.9,
  introductoryPeriodMonths: 12,
  additionalTeamMemberMonthly: 4.9,
  additionalStoreMonthly: 9.9,
  smsPerMessage: 0.03,
  whatsAppPerMessage: 0.1,
  smsMonthlyLimit: 30,
  includedTeamMembers: 1,
};
